import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { useCallback } from 'react'
import { parseCourse } from './ingestion/course'
import { IMCourse, IMUnit } from './types'
import {
  partnerIdAtom,
  useUploadCourse,
} from '../../components/ingestion/atoms'

export const PartnerKey = 'IM360'

export function fileNameForCourse(course: IMCourse) {
  return `${course.curricula.grade_band.slug}_${course.curricula.slug}_${course.slug}_SP`
}

export function useUploadIMCourse() {
  useSetAtom(partnerIdAtom)(PartnerKey)
  const uploader = useUploadCourse()
  return useCallback(
    (course: IMCourse) => {
      return uploader(parseCourse(course), fileNameForCourse(course))
    },
    [uploader],
  )
}

export function isUnit(something: unknown): something is IMUnit {
  return (
    !!something &&
    typeof something === 'object' &&
    'assessments' in something &&
    'sections' in something
  )
}
